// Start the next screenfuls of imagery before scrolling brings them into view.
// Keep distant images lazy so they do not compete with the hero or PDP gallery.
function preloadSectionImages() {
  const content = document.getElementById('MainContent');
  if (!content || typeof IntersectionObserver !== 'function') return;

  const pending = new Set();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting || !content.contains(entry.target)) continue;
      entry.target.loading = 'eager';
      observer.unobserve(entry.target);
      pending.delete(entry.target);
    }
  }, {
    rootMargin: `${Math.min(4000, Math.max(2000, window.innerHeight * 2))}px 0px`,
  });

  function observeImages(node) {
    if (node.nodeType !== 1) return;
    const images = node.matches('img[loading="lazy"]')
      ? [node]
      : node.querySelectorAll('img[loading="lazy"]');
    for (const image of images) {
      if (pending.has(image)) continue;
      pending.add(image);
      observer.observe(image);
    }
  }

  observeImages(content);
  // Recommendations, collection filters, pagination and the theme editor all
  // insert fresh markup. Give those images the same head start as the page HTML.
  new MutationObserver((records) => {
    for (const image of pending) {
      if (content.contains(image)) continue;
      observer.unobserve(image);
      pending.delete(image);
    }
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (content.contains(node)) observeImages(node);
      }
    }
  }).observe(content, {childList: true, subtree: true});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', preloadSectionImages, {once: true});
} else {
  preloadSectionImages();
}
